
  <div class="container_wrapper">
    <div class="blank_msg">
        <i class="bi bi-lock"></i>
        <h5>アクセス制限 | Access Restricted</h5>
        <p>当サイトへのアクセスは制限されています。</p>
        <p>You Do not have permission to access this site.</p>
    </div>
  </div>
